import React from "react";

export const FooterLayOut = () => {
  return <div>FooterLayOut</div>;
};
